import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-mail',
  templateUrl: './icon-mail.component.html',
  styleUrls: ['./icon-mail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconMailComponent {}
